import { render, staticRenderFns } from "./FurnitureCard.vue?vue&type=template&id=85721030&scoped=true&"
import script from "./FurnitureCard.vue?vue&type=script&lang=js&"
export * from "./FurnitureCard.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/furnitures.scss?vue&type=style&index=0&id=85721030&lang=scss&scoped=true&"
import style1 from "./FurnitureCard.vue?vue&type=style&index=1&id=85721030&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85721030",
  null
  
)

export default component.exports